import ReferralsPage from './ReferralsPage';

export default ReferralsPage;